import { PlayerCapabilities, WebPlayer} from "ATVWebPlayer"
import { loadWebPlayer } from "./loader"
import { initializePlayer, PlayerContentConfig } from "./index"
import { PlayerConfigData } from "./config"

let capabilities: PlayerCapabilities

export const _resetCapabilities = () => {
  capabilities = undefined as any as PlayerCapabilities
}

export const onCapabilities = (cb: (capabilities: PlayerCapabilities) => void) => {
  if (capabilities) {
    cb(capabilities)
  } else {
    loadWebPlayer().then((player: WebPlayer) => {
      player.on('playerCapabilities', (c10s: PlayerCapabilities) => {
        capabilities = c10s
        cb(capabilities)
      })
    })
  }

}

const isLivePlaybackRequest = (playbackArgs: PlayerContentConfig) => (
  playbackArgs.videoType === "Live" || playbackArgs.lcid || playbackArgs.live
)

export const onLiveIncompatible = (playerConfigData: PlayerConfigData, playerIncompatibleError: Function) => {

  const liveCheck = (playbackArgs: PlayerContentConfig) => (
    new Promise((resolve, reject) => {
      if (isLivePlaybackRequest(playbackArgs)) {
        onCapabilities((capabilities: PlayerCapabilities) => {
          if (capabilities.supportsLive === false) {
            playerIncompatibleError()
            reject()
          } else {
            resolve()
          }
        })
      } else {
        resolve()
      }
    })
  )

  initializePlayer(playerConfigData).runBeforePlay(liveCheck)
}

